import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { KycExpiredDialogComponent } from '../components/kyc-expired-dialog/kyc-expired-dialog.component';
import { KycHighRiskDialogComponent } from '../components/kyc-high-risk-dialog/kyc-high-risk-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class KycStatusService {

  constructor(private matDialog: MatDialog) { }
  openKycExpiredDialog() {
    this.matDialog.open(KycExpiredDialogComponent, {
      width: '50%'
    })
  }
    openKycHighRiskDialog() {
    this.matDialog.open(KycHighRiskDialogComponent, {
      width: '50%'
    })
  }
}
